import Vue from 'vue'

Vue.component('display-bcrypt-rounds', () => import('./BcryptRounds.vue'))
Vue.component('display-app-debug', () => import('./DebugMode.vue'))
Vue.component('display-json-object', () => import('./JsonObject.vue'))
Vue.component('display-cors-allowed-headers', () => import('./CorsAllowedHeaders.vue'))
Vue.component('display-source-control', () => import('./SourceControl.vue'))
Vue.component('display-system-user', () => import('./SystemUser.vue'))
Vue.component('display-session-http-only', () => import('./SessionHttpOnly.vue'))
Vue.component('display-cors-allowed-origins', () => import('./CorsAllowedOrigins.vue'))
Vue.component('display-session-lifetime', () => import('./SessionLifetime.vue'))
Vue.component('display-csrf-exclusion', () => import('./CsrfExclusion.vue'))
Vue.component('display-hashing-cipher', () => import('./HashingCipher.vue'))
Vue.component('display-last-composer-update', () => import('./LastComposerUpdate.vue'))
Vue.component('display-hashing-driver', () => import('./HashingDriver.vue'))
Vue.component('display-scan-schedule', () => import('./ScanSchedule.vue'))
Vue.component('display-session-samesite-cookies', () => import('./SamesiteCookies.vue'))
Vue.component('display-encrypted-session', () => import('./EncryptedSession.vue'))
Vue.component('display-secure-cookies', () => import('./SecureCookies.vue'))